/** @import { scimGroupResponse, scimOrgMappingResponse } from "~/backend/validate.js"; */

/** @import { Placement } from "~/util/float.js"; */

import { dropdown } from "~/component/Dropdown.js";

import { saveMappings } from "./manageMappings.js";
import Roles from "~/admin/lib/roles.js";

/**
 * @param {{ anchor: HTMLButtonElement; enterpriseId: string; placement: Placement }} props
 * @param {scimGroupResponse} group
 * @param {scimOrgMappingResponse[]} mappings
 */
export const changeMappingRole = async (
	{ anchor, enterpriseId, placement },
	group,
	...mappings
) => {
	const res = (
		await dropdown({
			anchor,
			placement,
			items: Roles.org.map(role => ({ text: role.label, role })),
		})
	)?.role;
	if (res === undefined) return;

	const title =
		mappings.length === 1
			? `Grant ${group.name} ${res.label} in ${mappings[0]?.org_name}?`
			: `Grant ${group.name} ${res.label} in ${mappings.length} organizations?`;
	if (!(await Roles.confirm(res, title))) return;

	const orgIds = new Set(mappings.map(mapping => mapping.org_id));
	return saveMappings(
		{ enterpriseId },
		group,
		group.mappings.map(mapping =>
			orgIds.has(mapping.org_id) ? { ...mapping, role: res.key } : mapping,
		),
	);
};
